import { IconPaths, ModalSize } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button, useModal } from 'app/components'
import { ModeloModal } from '../modal/ModeloModal'

export const ModelosListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()

  const openModal = () =>
    showModal({
      title: `${t('common.create')} ${t('modelo.label')}`,
      content: <ModeloModal />,
      size: ModalSize.Medium,
    })

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={openModal}>
      {t('common.add')}
    </Button>
  )
}
